<template>
  <div>
    <OnboardingTextSection>
      Рекламные площадки в Marilyn называются<br> <b>Каналы</b>.
    </OnboardingTextSection>

    <OnboardingTextSection>
      Если вы хотите подключить <b>кабинеты рекламных<br>
        площадок или систем</b>, то оставайтесь на вкладке<br>
      «Каналы».
    </OnboardingTextSection>

    <OnboardingTextSection>
      Если вам нужно подключить <b>кабинеты веб-<br>аналитики</b>, то перейдите во вкладку<br>
      «Веб-аналитика».
    </OnboardingTextSection>
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';

  export default {
    name: 'ConnectionsChannelAndWebAnalyticStep',
    components: {OnboardingTextSection}
  };
</script>
